export default {"src":"https://webcdn.trailways.com/_next/static/media/chevron-dark-up-faq.83277fc1.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};